import type { LngLatBoundsLike } from 'react-map-gl/maplibre'

export const mapZIndex = {
  dotMarker: 1,
  labelMarker: 2,
  sponsoredMarker: 3,
  poiMarker: 4,
  hoveredMarker: 5,
  markerPopup: 8,
  updateControls: 10,
  filters: 11
}

export const markerCounts = {
  // desktop:
  max_markers: 250,
  max_sponsored_labels: 15,
  max_total_labels: 20,
  // mobile:
  max_markers_mobile: 100,
  max_sponsored_labels_mobile: 10,
  max_total_labels_mobile: 15
}

export const zoomLevels = {
  max: 18,
  default: 11,
  defaultHood: 13,
  labelsOnAllMarkers: 14.5
}

export const defaultCoords = [49.256253658122446, -123.12404038633632]

// Canada bounds for map viewport
export const CANADA_BOUNDS = [
  [-126.88818661043646, 35.32016689712147],
  [-71.78076473543706, 72.1559413589888]
] as LngLatBoundsLike

// Default bounds for mobile list view fallback
export const DEFAULT_BOUNDS = {
  topLeft: {
    lat: 72.03434798231243,
    lon: -123.06494442293696
  },
  bottomRight: {
    lat: 35.64223043864537,
    lon: -71.64892879793723
  }
}
